import React, {useState} from "react"
import theme from "./../../../Theme/Theme"
import { Div, Text } from "atomize";
import styled from "styled-components";
import Card from "../../Atoms/Card";
import {PrimaryButton} from "../../Atoms/Button";
import ShareStoryModal from "../ShareStoryModal";

const StyledCard = styled(Div)`
  background-color: #00458C !important;
	width: 100%;
	border-radius: 2px;
  justify-content: center;
  align-items: center;
  display: flex;
  max-width: 450px;
`;

const Body = styled(Div)`
	width: 100%;
	button {
	  background-color: white !important;
	  span {
	   color: ${theme.colors.dark} !important;
   }
	}
`;

const Title = styled(Text)`
  color: #FFFFFF;	
  font-family: Inter;	
  font-size: 24px;	
  font-weight: 600;	
  line-height: 36px;	
  text-align: center;
  margin: 0 0 1rem 0 !important
`;

const Description = styled(Text)`
  color: #FFFFFF;	
  font-family: Inter;	
  font-size: 16px;	
  line-height: 28px;	
  text-align: center;
`;

function StoriesPromptCard(props) {
  const [open, setOpen] = useState(false);
  return (
    <StyledCard
      p={'1rem'}
      width={'450px'}
      shadow="3"
    >
      <Body>
        <Title>
          Share your <u>own</u> stories
        </Title>
        <Description>
          We welcome your stories of use and adaptation of Engineering for Humanity materials, whether it’s a small inspiration or a large-scale adaptation. Please share a story with us below, or by email. We’ll reach out to you, and we may ask your permission to show it on our website!
        </Description>
        <div
          style={{ textAlign: 'center'}}
        >
          <PrimaryButton
            type={'button'}
            action={() => setOpen(true)}
            text={'Share your story'}
          />
          <ShareStoryModal
            open={open}
            close={() => {
              setOpen(false)
            }}
          />
        </div>
      </Body>
    </StyledCard>
  )
}

export default StoriesPromptCard
